import React from 'react';
import { Date } from 'common';

const OptionalLienParameters: React.FC<{
  from?: Date;
  to?: Date;
  bookTypeText?: string;
}> = ({ from, to, bookTypeText }) => {
  const getDateDisplay = (date: Date | undefined, displayText: string) => {
    if (from || to) {
      return date ? (
        <>
          {' '}
          {displayText} <Date>{date}</Date>
        </>
      ) : (
        <> {displayText} Not Entered</>
      );
    } else {
      return null;
    }
  };

  return (
    <>
      {getDateDisplay(from, 'from')}
      {getDateDisplay(to, 'to')}
      {bookTypeText && <> for {bookTypeText} Book Type</>}
    </>
  );
};

export default React.memo(OptionalLienParameters);
